module.exports = __webpack_public_path__ + "img/315-5a3783.png";